export default "__VITE_ASSET__1b3e64b3__"